<div
  *transloco="let t; read: 'action-plan-dialog'"
  class="xi-modal__container action-plan-dialog__container"
>
  <h2 class="xi-modal__title action-plan-dialog__title">
    {{ t('title') }}
  </h2>

  <div class="xi-modal__content action-plan-dialog__modal-content">
    @if (isLoading) {
      <div class="xi-loader-container__center">
        <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
      </div>
    } @else {
      <div class="action-plan-dialog__content">
        <form [formGroup]="form" class="action-plan-dialog__form">
          <div class="action-plan-dialog__main-row">
            <div class="action-plan-dialog__field">
              <label class="kxi-label action-plan-dialog__field-label">{{ t('owner') }}</label>
              <xi-input-field formControlName="creator"></xi-input-field>
            </div>
            <div class="action-plan-dialog__field">
              <label class="kxi-label action-plan-dialog__field-label">{{ t('due') }}</label>
              <xi-date-picker [minDate]="minDueDate" formControlName="dueDate"></xi-date-picker>
            </div>
            <div class="action-plan-dialog__field">
              <label class="kxi-label action-plan-dialog__field-label">{{ t('status') }}</label>
              <xi-dropdown formControlName="status" [data]="statusDs"></xi-dropdown>
            </div>
          </div>
          <xi-text-area formControlName="notes" [placeholder]="t('notes-placeholder')" type="text">
          </xi-text-area>
        </form>
        <hr class="action-plan-dialog__separator" />
        <app-action-item-table
          [items]="items"
          [selectedItem]="selectedItem"
          [disabled]="isActionItemTableDisabled"
          (select)="onSelectItem($event)"
        ></app-action-item-table>
        <app-action-item-editor
          [mode]="actionItemEditorMode"
          [item]="selectedItem"
          (save)="onItemEditorSave($event)"
          (cancel)="onItemEditorCancel()"
          (delete)="onItemEditorDelete()"
          (valueChange)="onItemEditorValueChange()"
        ></app-action-item-editor>
      </div>
    }
  </div>

  <div class="xi-modal__actions action-plan-dialog__actions">
    <xi-default-button
      [text]="t('cancel')"
      [disabled]="isCancelDisabled"
      fill="text"
      (onClick)="onCancel()"
    ></xi-default-button>

    <div class="xi-loader-button-container">
      <xi-default-button
        [text]="t('save')"
        [disabled]="isSaveDisabled"
        (onClick)="onSave()"
      ></xi-default-button>

      @if (isSaving) {
        <div class="xi-loader-container__inline-overlay">
          <xi-animation
            [height]="75"
            [width]="75"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      }
    </div>
  </div>
</div>
